import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import VueLazyload from 'vue-lazyload'
import infiniteScroll from 'vue-infinite-scroll'
import VueCookie from 'vue-cookie'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import api from '../common/request/request.js'
import yxz_config from '../common/config/config.js';
import drag from '../config/drag.js';
import Base64 from "../common/base64";

import {
  parseTime,
  parseMoney,
  getFileType,
  getFileName,
  renameFileName,
  noPassByName,
  timeFormat
} from '@/utils/utils'

import {
  Button,
  Pagination,
  Checkbox,
  Icon,
  Autocomplete,
  Loading,
  Message,
  Notification,
  Steps,
  Step,
  Table,
  TableColumn,
  Input,
  Radio,
  Dialog,
  Select,
  Option,
  DatePicker,
  Empty,
  Upload
} from 'element-ui'

import VueContentPlaceholders from 'vue-content-placeholders'
import {
  setStore,
  getStore,
  removeStore
} from '/utils/storage.js'
Vue.use(ElementUI)
Vue.use(VueContentPlaceholders)
Vue.use(Button)
Vue.use(Pagination)
Vue.use(Checkbox)
Vue.use(Icon)
Vue.use(Autocomplete)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Input)
Vue.use(Radio)
Vue.use(Dialog)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(Empty)
Vue.use(Upload)
Vue.use(Loading.directive)
Vue.use(infiniteScroll)
Vue.use(VueCookie)
Vue.use(drag);
Vue.use(VueLazyload, {
  loading: '/static/images/load.gif'
})

// 挂载
Vue.prototype.$api = api
Vue.prototype.$loading = Loading.service
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message

Vue.prototype.parseTime = parseTime
Vue.prototype.parseMoney = parseMoney
Vue.prototype.getFileType = getFileType
Vue.prototype.getFileName = getFileName
Vue.prototype.renameFileName = renameFileName
Vue.prototype.noPassByName = noPassByName
Vue.prototype.timeFormat = timeFormat
Vue.prototype.$base64 = new Base64();

// 阻止启动生产消息，常用作指令。
Vue.config.productionTip = yxz_config.debug;

// 配置请求
api.setConfig({
  baseUrl: yxz_config.appurl,
  debug: yxz_config.debug
})

const whiteList = ['/home', '/login', '/register', '/news', '/newsDetail', '/school', '/courseDetail',
  '/mall', '/goodsDetail', '/3Dmodel','/resetPassword','/ai','/contact'
] // 不需要登陆的页面

router.beforeEach(function(to, from, next) {

  //在頁面加載時讀取sessionStorage裡的狀態信息
  if (sessionStorage.getItem('store')) {
    store.replaceState(Object.assign({}, store.state, JSON.parse(sessionStorage.getItem('store'))));
    //重置store之後將sessionStorage裡面的store清空
    sessionStorage.removeItem('store');
  }

  //在頁面刷新前將vuex裡的信息保存到sessionStorage
  window.addEventListener('beforeunload', () => {
    sessionStorage.setItem('store', JSON.stringify(store.state));
  });
  // 判断是否已登录
  api.get({
    url: '/user/checkLogin'
  }).then(res => {
    // console.log("checkLogin......", res);
    // console.log("to.path......", to.path);
    if (res.code === 401) { // 没登录
      if (whiteList.indexOf(to.path) !== -1) { // 白名单
        next()
      } else {
        Message({
          message: res.msg,
          type: 'error'
        })
        setTimeout(function() {
          // 携带原目标地址（含路由参数），登录成功后跳回
          next({
            path: '/login',
            query: { redirect: to.fullPath }
          })
        }, 1000);
      }
    } else {
      store.commit('common/recordDict', res.data.dictList)
      store.commit('common/recordServCata', res.data.servList)
      store.commit('common/recordImplDict', res.data.implList)
      store.dispatch('user/login', res.data)
      if (to.path === '/login') { //  跳转到
        const redirect = to.query.redirect
        // 已登录时若带有回跳地址则直接回跳，避免死循环跳回登录页
        next({
          path: redirect && redirect.indexOf('/login') !== 0 ? redirect : '/'
        })
        return
      }
      let userType = res.data.userInfo.userType;
      if(userType == '99'&& (['/order/mall','/order/des','/order/create','/order/dem'].includes(to.path))){
        next('/home')
      }else if((userType=='10'&&['/order/mall','/order/des'].includes(to.path))||(userType=='20'&&['/order/create','/order/dem'].includes(to.path))){
        next('/home')
      }else{
        next()
      }
    }
  })

})

/**
 * 修改标题栏
 * @param {Object} text 新标题
 */
const title = (text = '') => {
  if (text) {
    document.title = text
  }
}
/**
 * oss图片链接
 * @param {Object} url 图片地址
 */
const oss_img = (url) => {
	if(!url){
		return '';
	}
	return yxz_config.cdnurl + url;
}
/**
 * 富文本处理
 * @param {Object} str 需处理内容
 */
const showHtml = (str) => {
  if(str) {
    return str
      .replace(str ? /&(?!#?\w+;)/g : /&/g, '&amp;')
      .replace(/&lt;/g,"<")
      .replace(/&gt;/g,">")
      .replace(/&quot;/g,"\"")
      .replace(/&#39;/g, "\'")
      .replace(/&amp;nbsp;/g,'\u3000')
  }
}

/**
 * 页面跳转
 * params和query区别，query相当于get显示在url上，params相当于post不显示
 * get获取参数 id = this.$route.query.id
 * post获取参数 id = this.$route.params.id
 * @param {Object} url 需要跳转的页面路径
 * @param {Object} data 是一个对象如{id: 1}
 * @param {Object} method 请求方式 get或post
 */
const to = (url) => {
    router.push({
      path: url
    })
}

/**
 * 页面返回
 * @param {Object} num 返回页面数量
 */
const back = (num = -1) => {
  router.go(num)
}

/**
 * 提示信息
 * @param {Object} message 提示内容
 * @param {Object} type 默认类型error 包含success/warning/info/error
 * @param {Object} duration 显示时间,毫秒
 * @param {Object} center 文字是否居中
 * @param {Object} showclose 是否显示关闭按钮
 * @param {Object} offset Message 距离窗口顶部的偏移量
 */
const msg = (message, type = 'error', duration = 3000, center = false, showclose = true, offset = 20) => {
  //统一提示方便全局修改
  if (Boolean(message) === false) {
    return;
  }
  Message({
    message: message,
    type: type,
    duration: duration,
    center: center,
    showClose: showclose,
    offset: offset
  });
}
// url拼接
const url = (url) => {
  if (!url) {
    //加载默认图片
    return;
  }
  return yxz_config.appurl + url;
}
//统一挂载
Vue.prototype.$yxz = {
  to,
  back,
  title,
  msg,
  url,
  showHtml,
  oss_img
};
new Vue({
  el: '#app',
  store, //在全局vue实例挂载store
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js